import { useScopedField } from '@ngt/forms-core';
import { FC } from 'react';
import StripePayment from './StripePayment';

interface IFormPaymentProps {
    handleStripePaymentComplete: (clientReferenceId?: string) => void;
    handlePaymentCancel: () => void;
}

const FormPayment: FC<IFormPaymentProps> = ({ handleStripePaymentComplete, handlePaymentCancel }) => {
    const { state: { value: cost } } = useScopedField<number>('cost', { value: true });
    const { state: { value: email } } = useScopedField<string>('email', { value: true });

    return (
        <StripePayment
            handleStripePaymentComplete={handleStripePaymentComplete}
            handleCancel={handlePaymentCancel}
            cost={cost ?? 0}
            email={email ?? undefined}
        />
    );
};

export default FormPayment;
